import GraphQLClient from 'ts/GraphQLClient'
import { CREATE_INVOICE } from './graphql/createInvoice'

class MonthCloseRepo {
  constructor({ GRAPHQL_URL, ID_TOKEN = '' }) {
    this.client = new GraphQLClient({ url: GRAPHQL_URL, idToken: ID_TOKEN })
  }

  async createInvoice({ invoice }) {
    try {
      const response = await this.client.request({
        query: CREATE_INVOICE,
        variables: {
          invoice
        }
      })

      return response.createInvoice
    } catch (error) {
      throw new Error(`Failed to create invoice: ${error.message}`)
    }
  }
}

export default MonthCloseRepo
